var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"item-block"},[_c('span',{staticClass:"item-block-title",class:{ uppercase: _vm.titleUppercase !== undefined }},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2),_c('span',{staticClass:"item-block-subtitle"},[_vm._t("subtitle",function(){return [_vm._v(_vm._s(_vm.subtitle))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }